import * as React from 'react';
import { Form } from 'react-bootstrap';
import { getLocalization } from 'global/global';
import { AdminUserDraft, SsoField } from 'Interfaces/Admin';

interface Props {
  user: AdminUserDraft;
  /** SAML is offered only to accounts configured for it. */
  samlAvailable: boolean;
  onChange: (field: SsoField, checked: boolean) => void;
}

/** The mutually exclusive single sign-on options. */
export default function SsoOptions(props: Props) {
  const { user } = props;
  return (
    <Form.Group className="mb-2">
      <Form.Check
        id="user-uses-sso"
        label={(<strong>{getLocalization('googleSignin')}</strong>)}
        checked={!!user.usesSso}
        onChange={(e) => props.onChange('usesSso', e.target.checked)}
      />
      <Form.Check
        id="user-apple-signin"
        label={(<strong>{getLocalization('appleSignin')}</strong>)}
        checked={!!user.appleSignin}
        onChange={(e) => props.onChange('appleSignin', e.target.checked)}
      />
      {props.samlAvailable && (
        <Form.Check
          id="user-saml-sso"
          label={(<strong>{getLocalization('samlSignin')}</strong>)}
          checked={!!user.samlSso}
          onChange={(e) => props.onChange('samlSso', e.target.checked)}
        />
      )}
    </Form.Group>
  );
}
